import {
  APPLICATION_TYPE,
  type ApplicationType,
} from './application-general.model';

export const isApplicationTypeSubmitDisabled = ({
  draft,
  applicationType,
  hasApiDocumentation,
  hasStagedApiDocumentationChanges,
}: {
  draft: ApplicationType;
  applicationType: ApplicationType;
  hasApiDocumentation: boolean;
  hasStagedApiDocumentationChanges: boolean;
}): boolean => {
  const isSwitchingToBackendOnly =
    draft === APPLICATION_TYPE.backendOnly &&
    applicationType !== APPLICATION_TYPE.backendOnly;
  const hasRequiredApiDocumentation =
    hasApiDocumentation || hasStagedApiDocumentationChanges;

  return (
    (draft === applicationType && !hasStagedApiDocumentationChanges) ||
    (isSwitchingToBackendOnly && !hasRequiredApiDocumentation)
  );
};
